import { render, staticRenderFns } from "./localization.vue?vue&type=template&id=578ce8c6&scoped=true&"
import script from "./localization.ts?vue&type=script&lang=ts&"
export * from "./localization.ts?vue&type=script&lang=ts&"
import style0 from "./localization.scss?vue&type=style&index=0&id=578ce8c6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578ce8c6",
  null
  
)

export default component.exports